// extracted by mini-css-extract-plugin
module.exports = {"emptyDataWrapper":"Emptydata_emptyDataWrapper__1LwRd"};